import React from 'react'
import {Icon} from '@chakra-ui/react'

const CheckCircleIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" fill="transparent" data-testid="check-icon" {...props}>
            <circle cx="20" cy="20" r="20" fill="#0F8A0F" />
            <path
                d="M14.5825 29.2307C13.752 29.2307 12.971 28.9045 12.3877 28.3211L7.28625 23.2296C6.90068 22.844 6.90068 22.2212 7.28625 21.8356C7.67183 21.45 8.29468 21.45 8.68025 21.8356L13.7817 26.937C14.2068 27.3622 14.9483 27.3622 15.3734 26.937L31.0139 11.2867C31.3995 10.9011 32.0223 10.9011 32.4079 11.2867C32.7935 11.6723 32.7935 12.2951 32.4079 12.6807L16.7674 28.3211C16.1841 28.9045 15.4031 29.2307 14.5726 29.2307H14.5825Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default CheckCircleIcon
